import { Text } from "@clipboard-health/ui-components";
import { Box, Stack, type Theme } from "@mui/material";
import { TIERS_CARD_IMAGE_PADDING } from "@src/appV2/redesign/Tiers/utils/constants";

interface BaseTierCardProps {
  title: string;
  content?: React.ReactNode;
  footer?: React.ReactNode;
}

export function BaseTierCard(props: BaseTierCardProps) {
  const { title, content, footer } = props;
  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      gap={10}
      sx={{ minHeight: (theme: Theme) => theme.size?.shiftCard.minHeight }}
    >
      <Stack direction="column" gap={2}>
        <Text semibold variant="h4" textAlign="left">
          {title}
        </Text>
        {/* save room for bespoke Tier image */}
        <Box sx={{ maxWidth: `calc(100% - ${TIERS_CARD_IMAGE_PADDING}px)` }}>{content}</Box>
      </Stack>
      {footer}
    </Stack>
  );
}
